/**
 * ERP field-write authorization checks for UX (UI visibility/hiding).
 *
 * IMPORTANT: the backend fully enforces this — `WriteErpFieldUseCase`
 * requires Quality+ on both preview and commit. These are UX checks only,
 * so a sub-Quality user never sees the write affordance in the first place
 * (uxConventions §9.2: hide actions, don't disable them).
 */

import type {UserRole} from '@/matic/types/roles';

export function canWriteErpFields(userRole: UserRole | undefined): boolean {
  return userRole === 'admin' || userRole === 'quality';
}
